export const PATH_PAGE = {
  root: "/",
  auth: {
    root: "auth",
    welcome: "welcome",
    login: {
      root: "login",
      forgotPassword: "forgot-password",
      forgotPasswordVerify: "code-verify",
    },
  },
  onboarding: {
    root: "onboarding",

    chooseAccType: "choose-account-type",
    createAccount: "create-account",
    residencyNationality: "residency-nationality",

    registerGender: "register-gender",
    registerBirthday: "register-birthday",
    registerCitizenship: "register-citizenship",

    chooseDocType: "choose-document-type",

    uploadCredentials: "citizenship-documents",

    // selfieWithDocumentPage: "selfie-with-document",
    utilityBillPhotoPage: "utility-bill",

    personalAddress: "personal-address",
    pinCode: "pin-code",
  },
  app: {
    root: "",
    verification: {
      root: "verification",
      details: "details", // name - company name
      businessDocuments: "business-documents",
      dateOfBirth: "date-of-birth",
      residenceAddress: "residence-address",
      phoneNumber: "phone-number",
      email: "email",
      identityVerification: "identity-verification",
      chooseDocType: "choose-document-type",
      selfieWithDocument: "selfie-with-document",
      proofOfAddress: "proof-of-address",
    },
    home: {
      root: "home",
      editRates: "edit-rates",
      unfinishedTransactions: "unfinished-transactions",
    },
    strategy: "strategy/:asset_id",
    invest: "strategy/:asset_id/:operation",
    discover: {
      root: "discover",
      research: "research/:alias",
      blog: "blog/:alias",
      // strategy: "strategy/:asset_id",
      // invest: "strategy/:asset_id/:operation",
    },
    market: {
      root: "market",
      search: "asset-search",
      filter: {
        root: "filter",
        createStockFilter: "create-stock-filter",
        createBondFilter: "create-bond-filter",
        filterReview: "filter-review",
      },
      stock: ":asset_id/stock-details",
      // strategy: ":asset_id/strategy-details",
      bond: ":asset_id/bond-details",
      currency: ":asset_id/currency-details",
      optionChain: ":asset_id/option-chain",
      calendar: "calendar",
      buy: ":asset_id/buy",
      sell: ":asset_id/sell",
    },
    chat: {
      root: "chat",
      support: "support",
      ai: "ai",
    },
    account: {
      root: "account",
      personal: {
        root: "personal-info",
        changeEmail: "change-email",
        verifyChangedEmail: "verify-email",
        changePhone: "change-phone-number",
        verifyChangedPhone: "verify-phone-number",
      },

      //! >
      // citizenship: "verification/citizenship",
      // identityVerification: "verification/identity-verification",
      // registerGender: "verification/register-gender",
      // registerBirthday: "verification/register-birthday",
      // registerCitizenship: "verification/register-citizenship",
      // chooseDocType: "verification/choose-document-type",
      // proofOfAddressAddressPhotoPage: "verification/proof-of-address",
      // selfieWithDocumentPage: "verification/selfie-with-document",
      // utilityBillPhotoPage: "verification/utility-bill",
      // personalAddress: "verification/personal-address",
      // signBusinessContract: "verification/sign-business-contract",
      //! <

      questions: "questions",

      myBonuses: "my-bonuses",

      repoDeals: "repo-deals",
      repoTransaction: "repo-transaction",
      subAccounts: "sub-accounts",
      repoTransactionHistory: "repo-transaction-history",

      security: {
        root: "security",
        changePassword: "change-password",
        changePIN: "change-pin",
        pinCode: "pin-code",
      },
      tariffs: "tariffs",
      deposit: "deposit",
      withdrawal: "withdrawal",
      history: {
        root: "history",
        historySearch: "search",
      },
      brokerageReport: "brokerage-report",
      taxReport: "tax-report",
      signContract: "sign-contract",
      assignments: "assignments",
      assignment: "assignments/:type",
      assignmentSignContract: "assignments/:type/sign-contract/:id",
      assignmentsHistory: "assignments/history",
      assignmentsIndividualHistory: "assignments/:type/history",

      taxInformation: "tax-information",
    },
    portfolio: {
      root: "portfolio",
    },
    currencies: {
      root: "currencies",
      currencyOrder: ":asset_id/currency-details",
    },
  },
  page404: "/404",
};

export const PATH_LIST = {
  auth: "/auth",

  verification: "/verification",
  details: "/verification/details",
  residence: "/verification/residence",
  businessDocuments: "/verification/business-documents",
  dateOfBirth: "/verification/date-of-birth",
  residenceAddress: "/verification/residence-address",
  phoneNumber: "/verification/phone-number",
  email: "/verification/email",
  identityVerification: "/verification/identity-verification",
  chooseDocType: "/verification/choose-document-type",

  uploadCredentials: "/verification/citizenship-documents",

  selfieWithDocument: "/verification/selfie-with-document",
  proofOfAddress: "/verification/proof-of-address",

  home: "/home",
  editRates: "/home/edit-rates",
  unfinishedTransactions: "/home/unfinished-transactions",

  portfolio: "/portfolio",

  currencies: "/currencies",
  currencyOrder: (asset_id: any) => `/currencies/${asset_id}/currency-details`,

  discover: "/discover",
  research: (alias: any) => `/discover/research/${alias}`,
  blog: (alias: any) => `/discover/blog/${alias}`,

  market: "/market",
  search: "/market/asset-search",
  filter: "/market/filter",
  createStockFilter: "/market/create-stock-filter",
  createBondFilter: "/market/create-bond-filter",
  filterReview: "/market/filter-review",

  stock: (asset_id: any) => `/market/${asset_id}/stock-details`,
  // marketStrategy: (asset_id: any) => `/market/${asset_id}/strategy-details`,
  // marketStrategyInvest: (asset_id: any, operation: string) =>
  //   `/market/strategy/${asset_id}/${operation}`,
  bond: (asset_id: any) => `/market/${asset_id}/bond-details`,
  currency: (asset_id: any) => `/market/${asset_id}/currency-details`,
  optionChain: (asset_id: any) => `/market/${asset_id}/option-chain`,
  buy: (asset_id: any) => `/market/${asset_id}/buy`,
  sell: (asset_id: any) => `/market/${asset_id}/sell`,

  strategy: (asset_id: any) => `/strategy/${asset_id}`,
  strategyInvest: (asset_id: any, operation: string) =>
    `/strategy/${asset_id}/${operation}`,

  chat: "/chat",
  chatAI: "/chat/ai",
  support: "/chat/support",

  account: "/account",
  personal: "/account/personal-info",
  // verifyEmail: "/account/personal-info/verify-email",
  changeEmail: "/account/personal-info/change-email",
  verifyChangedEmail: "/account/personal-info/verify-email",
  changePhone: "/account/personal-info/change-phone-number",
  verifyChangedPhone: "/account/personal-info/verify-phone-number",

  // ! >
  // citizenship: "/account/verification/citizenship",
  // identityVerification: "/account/verification/identity-verification",
  // registerGender: "/account/verification/register-gender",
  // registerBirthday: "/account/verification/register-birthday",
  // registerCitizenship: "/account/verification/register-citizenship",
  // chooseDocType: "/account/verification/choose-document-type",
  // selfieWithDocumentPage: "/account/verification/selfie-with-document",
  // proofOfAddressAddressPhotoPage: "/account/verification/proof-of-address",
  // personalAddress: "/account/verification/personal-address",
  // signBusinessContract: "/account/verification/sign-business-contract",
  // ! <

  utilityBillPhotoPage: "/account/verification/utility-bill",

  questions: "/account/questions",

  myBonuses: "/account/my-bonuses",

  repoDeals: "/account/repo-deals",
  repoDealsHistory: "/account/repo-deals-history",

  repoTransaction: "/account/repo-transaction", // long-term funds placement
  subAccounts: "/account/sub-accounts",
  repoTransactionHistory: "/account/repo-transaction-history",

  security: "/account/security",
  changePassword: "/account/security/change-password",
  pinCode: "/account/security/pin-code",
  changePIN: "/account/security/change-pin",

  deposit: "/account/deposit",
  withdrawal: "/account/withdrawal",

  history: "/account/history",
  historySearch: "/account/search",
  brokerageReport: "/account/brokerage-report",
  taxReport: "/account/tax-report",
  signUserContract: "/account/sign-contract",
  assignments: "/account/assignments",
  assignment: (type: string) => `/account/assignments/${type}`,
  assignmentSignContract: (type: string, id: number) =>
    `/account/assignments/${type}/sign-contract/${id}`,
  assignmentsHistory: "/account/assignments/history",
  assignmentsIndividualHistory: (type: string) =>
    `/account/assignments/${type}/history`,

  taxInformation: "/account/tax-information",

  tariffs: "/account/tariffs",

  welcome: "/auth/welcome",
  login: "/auth/login",
  //!
  loginPassword: "/auth/login/password",
  forgotPassword: "/auth/login/forgot-password",
  forgotPasswordVerify: "/auth/login/code-verify",

  chooseAccType: "/onboarding/choose-account-type",
  createAccount: "/onboarding/create-account",
  residencyNationality: "/onboarding/residency-nationality",

  registerPhone: "/onboarding/register-phone",
  verifyPhone: "/onboarding/verify-phone",
  registerEmail: "/onboarding/register-email",
  // verifyEmail: "/onboarding/verify-email",
  companyName: "/onboarding/your-company",
  registerName: "/onboarding/register-name",
  createPassword: "/onboarding/create-password",
  // registerGender: "/onboarding/register-gender",
  // registerBirthday: "/onboarding/register-birthday",
  // registerCitizenship: "/onboarding/register-citizenship",
  hopeToAchieve: "/onboarding/hope-to-achieve",
  investingExperience: "/onboarding/investing-experience",
  whatDoYouDoForALiving: "/onboarding/for-a-living",
  investingWithSavings: "/onboarding/investing-with-savings",
  // chooseDocType: "/onboarding/choose-document-type",
  // proofOfAddressAddressPhotoPage: "/onboarding/proof-of-address",
  // selfieWithDocumentPage: "/onboarding/selfie-with-document",
  // utilityBillPhotoPage: "/onboarding/utility-bill",
  // personalAddress: "/onboarding/personal-address",
  // pinCode: "/onboarding/pin-code",
  termsAndConditions: "/onboarding/terms-and-conditions",
  accountHasBeenCreated: "/onboarding/account-created",
  // signContract: "/onboarding/sign-contract",
};
